import React, { useEffect, useState } from 'react';
import api from "../api/api";
import { Devices as DevicesIcon, People as PeopleIcon } from '@mui/icons-material';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import './Dashboard.css';

type TrendPoint = { day: string; value: number };

const Dashboard: React.FC = () => {
  const [deviceCount, setDeviceCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [deviceTrend, setDeviceTrend] = useState<TrendPoint[]>([]);
  const [userTrend, setUserTrend] = useState<TrendPoint[]>([]);

 useEffect(() => {
  const fetch = async () => {
    try {
      // existing KPI call
      const res = await api.get('/api/kpis');

      setUserCount(res.data.users.count || 0);
      setDeviceTrend(res.data.devices.trend || []);
      setUserTrend(res.data.users.trend || []);
      

      const deviceRes = await api.get('/api/audit/devices');

      setDeviceCount(deviceRes.data.length || 0);

    } catch (err) {
      console.error('Failed to fetch dashboard data', err);
    }
  };
  fetch();
}, []);

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>System Overview </p>
      </div>
      <div className="kpi-row">
        <div className="kpi-card devices-card">
          <div className="kpi-header">
            <div className="kpi-title-group">
              <h3>Devices Connected</h3>
              <p className="kpi-subtitle">Total Connected Devices</p>
            </div>
            <DevicesIcon className="kpi-icon" />
          </div>
          <div className="kpi-value">{deviceCount}</div>
        </div>

        <div className="kpi-card users-card">
          <div className="kpi-header">
            <div className="kpi-title-group">
              <h3>Total Users</h3>
              <p className="kpi-subtitle">System Accounts</p>
            </div>
            <PeopleIcon className="kpi-icon" />
          </div>
          <div className="kpi-value">{userCount}</div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
